<template>
  <div :id="containerId" style="width:100%;height:100%" ref="container"></div>
</template>

<script>
    export default {
        name:"mw-markdown-editor",
        data(){
          return {
            containerId:"mdeditor-"+(new Date().getTime())
          }
        },
        props:{
          mode:String,
          markdown:String,
        },
        mounted(){
          var me = this;
          var el = me.$refs.container;
          var css = [
            "/assets/js/editormd/lib/codemirror/codemirror.min.css",
            // "/assets/js/editormd/addon/search/matchesonscrollbar.css",
            "/assets/js/editormd/css/editormd.css"]
          var jsList = [
            "/assets/js/editormd/lib/codemirror/codemirror.min.js",
            "/assets/js/editormd/lib/codemirror/addons.min.js",
            "/assets/js/editormd/lib/codemirror/modes.min.js",
            "/assets/js/plugins/marked.min.js",
            "/assets/js/plugins/prettify.min.js",
            "/assets/js/editormd/editormd.min.js"]
          PF.loadCss(css);
          PF.requireJs(jsList, function() {
            let config = {
              autoHeight:me.autoHeight,
              toolbarIcons:"simple",
              width: "100%",
              height: $(me.$refs.container).height(),
              markdown: me.markdown,
              htmlDecode: "style,script,iframe",
              tocm: true,
              emoji: true,
              taskList: true,
              pluginPath:"/assets/js/editormd/plugins/",
              autoLoadModules:false
            }
            if (me.mode == "display") {
              me.editor = editormd.markdownToHTML(me.containerId, config);
            } else {
              me.editor = editormd(me.containerId, config);
            }
          })
        },
        methods:{
          getValue:function(){return this.editor && this.editor.getMarkdown()},
          getHtml:function(){return this.editor && this.editor.getPreviewedHTML()},
          setValue:function(s){
            if(this.editor) this.editor.setMarkdown(s)
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/components/extend/mdeditor/index.vue